import React from 'react';

function Trusted() {
  const boxes = [
    {
    
      icon: 'icon-money-transfer',
      title: 'Debt Consolidation',
      text: 'Simplify your finances. Our debt consolidation loans combine multiple debts into one monthly payment so you can save on interest and pay off debt faster.',
    },
    {
      icon: 'icon-bank-transfer',
      title: 'Home Improvement ',
      text: 'Renovate your home. Home improvement loans provide financing for remodeling, renovations, and major home projects so you can increase property value.',
    },
  ];

  return (
    <section className="about-one pt-80 pb-120">
      <div className="container">
        <div className="row row-gutter-y-80">
          <div className="col-lg-6">
            <div className="about-one__content">
              <div className="block-title text-left">
                <p className="block-title__tagline">About Company</p>
                <h2 className="block-title__title">
                  We’re Trusted leaders in credit auditing
                </h2>
              </div>
              <p className="about-one__text">
              When it comes to credit auditing, turn to the experts you can trust - ${process.env.REACT_APP_COMPANY_NAME}. For over 5 years, we have established ourselves as leading providers of comprehensive credit audit services. Our team of certified auditors leverage cutting-edge technology and proven strategies to deliver insightful audits that identify errors, potential fraud, and opportunities for credit improvement.
              </p>
              <div className="row row-gutter-y-20">
                {boxes.map((box, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="about-one__box">
                      <div className="about-one__box__icon">
                        <i className={box.icon}></i>
                      </div>
                      <div className="about-one__box__content">
                        <h3 className="about-one__box__title">{box.title}</h3>
                        <p className="about-one__box__text">{box.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="about-one__image">
              <img src="assets/images/resources/about-1-1.png" alt="" />
              <div className="about-one__image__caption">
                <span>We're provide best facility for your wishes</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Trusted;
